import { Banner, Button, Dialog } from '@cloudflare/kumo';
import { useNavigate } from 'react-router-dom';
import { usePlan } from '../contexts/PlanContext';
import { useTenant } from '../contexts/TenantContext';

/**
 * Faixa no topo do app: dias restantes do teste grátis, ou o motivo do bloqueio
 * (teste encerrado, assinatura suspensa/cancelada) com o caminho para regularizar.
 */
export function PlanBanner() {
  const { summary } = usePlan();
  const { can } = useTenant();
  const navigate = useNavigate();
  if (!summary) return null;

  const canPay = can('billing:manage');
  const cta = canPay ? (
    <Button variant="primary" onClick={() => navigate('/faturamento')} style={{ marginLeft: 12 }}>
      Escolher plano
    </Button>
  ) : null;

  if (summary.blocked) {
    return (
      <div style={{ margin: '12px 24px 0' }}>
        <Banner variant="error" description={<>
          <strong>{summary.blockedMessage}</strong>
          {canPay ? cta : <span> Peça ao responsável pelo faturamento da organização.</span>}
        </>} />
      </div>
    );
  }

  if (summary.planStatus === 'TRIAL' && summary.trialDaysLeft !== null) {
    const d = summary.trialDaysLeft;
    const when = d <= 0 ? 'termina hoje' : d === 1 ? 'termina amanhã' : `termina em ${d} dias`;
    return (
      <div style={{ margin: '12px 24px 0' }}>
        <Banner variant={d <= 2 ? 'alert' : 'default'} description={<>
          Seu teste grátis do plano <strong>{summary.plan?.displayName ?? 'Profissional'}</strong> {when}. Seus dados ficam guardados ao assinar.
          {cta}
        </>} />
      </div>
    );
  }

  return null;
}

/** Janela aberta por qualquer resposta 402 da API (recurso fora do plano ou acesso bloqueado) */
export function UpgradeModal() {
  const { upgrade, dismissUpgrade } = usePlan();
  const { can } = useTenant();
  const navigate = useNavigate();
  const blocked = upgrade?.code === 'TRIAL_EXPIRED' || upgrade?.code === 'SUSPENDED' || upgrade?.code === 'CANCELLED';

  return (
    <Dialog.Root open={!!upgrade} onOpenChange={(o: boolean) => { if (!o) (dismissUpgrade)(); }}>
<Dialog size="sm" className="p-6">
<Dialog.Title className="mb-4 text-lg font-semibold">{<h3 className="text-lg font-semibold">{blocked ? 'Acesso pausado' : 'Disponível em outro plano'}</h3>}</Dialog.Title>

      <p style={{ marginBottom: 24 }}>{upgrade?.message}</p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={dismissUpgrade}>Agora não</Button>
        {can('billing:manage') ? (
          <Button variant="primary" onClick={() => { dismissUpgrade(); navigate('/faturamento'); }}>
            {upgrade?.requiredPlan ? `Ver o plano ${upgrade.requiredPlan}` : 'Ver planos'}
          </Button>
        ) : null}
      </div>
      {!can('billing:manage') && (
        <p className="text-kumo-subtle" style={{ marginTop: 16 }}>
          Peça ao responsável pelo faturamento da organização para mudar de plano.
        </p>
      )}
    
</Dialog>
</Dialog.Root>
  );
}
